import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var GitBranch02 = function GitBranch02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M6 3v12m0 0c-1.6569 0-3 1.3431-3 3s1.3431 3 3 3 3-1.3431 3-3m-3-3c1.6569 0 3 1.3431 3 3m9-9c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3m0 0a9 9 0 0 1-2.636 6.364A9 9 0 0 1 9 18"
    })
  }));
};
export default GitBranch02;